export default "__VITE_ASSET__DL$PI0vk__"